<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Backend RH non déployé : données indisponibles (voir docs/backend-brief-hr.md).</div>
}

<div class="flexrow hr-header">
	<button mat-icon-button aria-label="Période précédente" (click)="onShift(-1)">
		<mat-icon>chevron_left</mat-icon>
	</button>
	<span class="period-label">{{ periodLabel }}</span>
	<button mat-icon-button aria-label="Période suivante" (click)="onShift(1)">
		<mat-icon>chevron_right</mat-icon>
	</button>
	<button mat-stroked-button (click)="onToday()">Aujourd'hui</button>

	<mat-button-toggle-group [value]="mode" (change)="onModeChange($event.value)" class="mode-toggle">
		<mat-button-toggle value="week">Semaine</mat-button-toggle>
		<mat-button-toggle value="month">Mois</mat-button-toggle>
	</mat-button-toggle-group>

	<span class="spacer"></span>
	<!-- Les relevés signés par les salariés qui attendent le VISA du responsable (event 4402). -->
	@if (isAdmin && pendingCountersign.length > 0) {
		<button mat-stroked-button id="countersignlistbutton" class="tosign"
			matTooltip="Relevés d'heures signés par les salariés, en attente de votre visa"
			(click)="onCountersign()">
			<mat-icon>approval</mat-icon>&nbsp;À viser&nbsp;({{ pendingCountersign.length }})
		</button>
	}
	<!-- Le document remettable en contrôle (art. D3171-8) : jour par jour, récapitulé par
	     semaine, un salarié par page avec émargement. Mêmes chiffres que le tableau. -->
	<button mat-stroked-button id="printledgerbutton"
		matTooltip="Relevé individuel du temps de travail (art. D3171-8) — jour par jour, récapitulé par semaine, un salarié par page"
		(click)="onPrintLedger()" [disabled]="dataSource.data.length === 0">
		<mat-icon>print</mat-icon>&nbsp;Relevé individuel
	</button>
	<button mat-stroked-button id="exportcsvbutton" (click)="onExportCsv()" [disabled]="dataSource.data.length === 0">
		<mat-icon>download</mat-icon>&nbsp;Export CSV
	</button>
</div>

<div class="pagecontent">
	<table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef>Employé</th>
			<td mat-cell *matCellDef="let row">
				{{ row.name }}
				@if (row.open_now) {
					<span class="present-dot" matTooltip="Actuellement badgé"></span>
				}
			</td>
		</ng-container>
		<ng-container matColumnDef="days">
			<th mat-header-cell *matHeaderCellDef>Jours travaillés</th>
			<td mat-cell *matCellDef="let row">{{ row.days_worked }}</td>
		</ng-container>
		<!-- Le temps RETENU, nommé d'après le mode de décompte : sans badgeuse, ce sont les heures
		     réalisées (le planning, ajusté par les clôtures et déclarations), pas un « badgé » à 0. -->
		<ng-container matColumnDef="worked">
			<th mat-header-cell *matHeaderCellDef>{{ source === 'clock' ? 'Badgé' : 'Réalisé' }}</th>
			<!-- UN SEUL tooltip pour toute la cellule : le sablier n'en porte pas le sien, sinon
			     le survoler en déclencherait deux qui se recouvrent. Son sens est déjà dans le
			     texte de `workedTooltip` (« Période en cours : … »). -->
			<td mat-cell *matCellDef="let row" class="num" [matTooltip]="workedTooltip(row)">
				{{ h(row.worked_min) }}
				@if (row.elapsed_min < row.planned_min) {
					<mat-icon class="pending">hourglass_top</mat-icon>
				}
			</td>
		</ng-container>
		<ng-container matColumnDef="planned">
			<th mat-header-cell *matHeaderCellDef>Planifié</th>
			<td mat-cell *matCellDef="let row" class="num">{{ h(row.planned_min) }}</td>
		</ng-container>
		<ng-container matColumnDef="delta">
			<th mat-header-cell *matHeaderCellDef>Écart</th>
			<td mat-cell *matCellDef="let row" class="num" [class.pos]="row.delta_min > 0" [class.neg]="row.delta_min < 0">
				{{ deltaLabel(row) }}
			</td>
		</ng-container>
		<ng-container matColumnDef="overtime">
			<th mat-header-cell *matHeaderCellDef>H. sup.</th>
			<td mat-cell *matCellDef="let row" class="num" [class.pos]="row.overtime_min > 0">
				{{ row.overtime_min > 0 ? h(row.overtime_min) : '—' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="absences">
			<th mat-header-cell *matHeaderCellDef>Absences (j)</th>
			<td mat-cell *matCellDef="let row">{{ row.absence_days || '—' }}</td>
		</ng-container>
		<ng-container matColumnDef="anomalies">
			<th mat-header-cell *matHeaderCellDef>Anomalies</th>
			<td mat-cell *matCellDef="let row">
				@if (row.anomalies.length > 0) {
					<span class="anomaly" [matTooltip]="anomaliesTooltip(row)">
						<mat-icon>warning</mat-icon>{{ row.anomalies.length }}
					</span>
				} @else {
					—
				}
			</td>
		</ng-container>
		<!-- Mode planning uniquement (cf. displayedColumns) : les journées passées SANS clôture
		     sont payées sur l'horaire prévu, sans qu'un humain l'ait confirmé. Le bouton
		     fact_check de la ligne est le geste qui les clôt. -->
		<ng-container matColumnDef="unclosed">
			<th mat-header-cell *matHeaderCellDef>À clore</th>
			<td mat-cell *matCellDef="let row">
				@if (row.unclosed.length > 0) {
					<span class="unclosed" [matTooltip]="unclosedTooltip(row)">
						<mat-icon>event_busy</mat-icon>{{ row.unclosed.length }}
					</span>
				} @else {
					—
				}
			</td>
		</ng-container>
		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let row">
				@if (isAdmin) {
					<button mat-icon-button matTooltip="Voir / corriger les pointages" aria-label="Voir ou corriger les pointages" (click)="onEditClocks(row)">
						<mat-icon>edit_calendar</mat-icon>
					</button>
					<!-- L8 — arbitrer le temps RÉMUNÉRÉ jour par jour ; c'est lui qui part en paie. -->
					<button mat-icon-button
						[matTooltip]="'Valider les heures jour par jour' + (validatedCount(row) ? ' (' + validatedCount(row) + ' déjà validée(s))' : '')"
						aria-label="Valider les heures jour par jour" (click)="onValidateDays(row)">
						<mat-icon [class.done]="validatedCount(row) > 0">fact_check</mat-icon>
					</button>
				}
			</td>
		</ng-container>

		<tr mat-header-row class="table_head" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
	</table>

	@if (hasPending) {
		<div class="pending-note">
			<mat-icon>hourglass_top</mat-icon>
			Période non terminée : le réalisé s'arrête à maintenant, l'écart ne porte que sur ce qui est échu.
		</div>
	}

	@if (dataSource.data.length === 0) {
		<div class="hr-empty">Aucune donnée sur la période (ni pointage, ni planning, ni absence).</div>
	}
</div>
